module.exports = __webpack_public_path__ + "static/media/icon-social_media-twitter.c4efff2d.svg";